﻿import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';

export const getBuildeablePlanCard$ = (id) =>
  fromFetch(`/ajax/getextendbuildableplanscard?communityId=${id}`).pipe(
    switchMap((response) => response.text())
  );

export const getCommunityExtendCard$ = (id) =>
  fromFetch(`/ajax/getextendcommunitycard?communityid=${id}`).pipe(switchMap((response) => response.text()));

export const getPlanExtendCard$ = (id) =>
  fromFetch(`/ajax/getplanextendcard?planid=${id}`).pipe(switchMap((response) => response.text()));

export const getSpecExtendCard$ = (id) =>
  fromFetch(`/ajax/getspecextendcard?specid=${id}`).pipe(switchMap((response) => response.text()));
